// Orden cronológico de los mensajes de una conversación.
//
// La API pagina en orden DESC (página 0 = lo más reciente). Antes el panel
// ordenaba EN SITIO el array de estado en cada render, y de rebote el resto del
// código veía los mensajes ascendentes: useMessages lee messages[length - 1]
// como «el último». Ahora se ordena una copia al pintar y la página se ordena
// una vez al entrar en el estado, para conservar ese contrato sin mutar.

// Instante de un mensaje para ordenar: createdAt (más preciso) antes que timestamp.
const instanteDe = (m) => {
  if (m.createdAt) return new Date(m.createdAt).getTime();
  if (m.timestamp) return new Date(m.timestamp).getTime();
  return 0;
};

// Orden cronológico sobre una COPIA: el array es estado de React y no se muta.
// A igual instante desempata el id de base de datos (orden de inserción).
export function ordenarMensajes(mensajes) {
  return (mensajes || [])
    .map((m) => ({ m, t: instanteDe(m) }))
    .sort((a, b) => (a.t === b.t ? (a.m.dbId || 0) - (b.m.dbId || 0) : a.t - b.t))
    .map(({ m }) => m);
}

export default ordenarMensajes;
